module.exports = __webpack_public_path__ + "static/img/landing.37a0f00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process/landing.svg
// module id = Jjvl
// module chunks = 1